"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("@r1-frontend/ui-react/components/layouts/wideContainer/index");

var _colors = require("@r1-frontend/ui-react/tokens/colors");

var _index2 = require("@r1-frontend/ui-react/tokens/fonts/index");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themes = _interopRequireDefault(require("./themes.js"));

var _excluded = ["children", "title", "open", "onOpen", "theme", "customTheme", "withDividingBorder"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Accordion__Wrapper",
  componentId: "dvcmv9-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-direction: column;\n    width: 100%;\n    background: ", ";\n    border: 1px solid ", ";\n    border-width: ", ";\n    border-radius: ", ";\n    padding: ", ";\n    color: ", ";\n\n    @media (max-width: ", ") {\n        padding: ", ";\n    }\n"])), function (props) {
  return props.theme.background;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.border ? theme.border : _colors.COLORS.GRAY_LIGHT;
}, function (props) {
  return props.theme.borderWidth;
}, function (props) {
  return props.theme.radius;
}, function (props) {
  return props.theme.padding;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color ? theme.color : _colors.COLORS.TextPrimary;
}, _index.wideBreakpoints.mobile, function (props) {
  return props.theme.mobilePadding;
});

var AccordionTitle = _styledComponents["default"].div.withConfig({
  displayName: "Accordion__AccordionTitle",
  componentId: "dvcmv9-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: nowrap;\n    cursor: pointer;\n\n    @media (max-width: ", ") {\n        ", ";\n    }\n"])), _index2.FONTS.L, _index.wideBreakpoints.mobile, _index2.FONTS.S);

var Title = _styledComponents["default"].div.withConfig({
  displayName: "Accordion__Title",
  componentId: "dvcmv9-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    width: calc(100% - 53px);  \n    ", ";\n\n    @media (max-width: ", ") {\n        width: calc(100% - 39px);\n        ", ";\n    }\n"])), function (props) {
  return props.theme.desktopFont || '';
}, _index.wideBreakpoints.mobile, function (props) {
  return props.theme.mobileFont || '';
});

var Icon = _styledComponents["default"].span.withConfig({
  displayName: "Accordion__Icon",
  componentId: "dvcmv9-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    position:relative;\n    margin-left: 20px;\n    flex: 0 0 36px;\n    height: 36px;\n    border-radius: 50%;\n    transform: ", ";\n    transition: all 0.2s ease-in;\n    svg {\n        display: block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        circle {\n            stroke: ", ";\n            fill: ", ";\n        }\n        path {\n            stroke: ", ";\n        }\n    }\n\n    @media (max-width: ", ") {\n        margin-left: 15px;\n        background-size: contain;\n    }\n"])), function (props) {
  return props.open ? 'none' : 'scaleY(-1)';
}, function (_ref3) {
  var borderIcon = _ref3.borderIcon;
  return borderIcon ? borderIcon : _colors.COLORS.GRAY_DARK;
}, function (_ref4) {
  var backgroundIcon = _ref4.backgroundIcon;
  return backgroundIcon ? backgroundIcon : _colors.COLORS.GRAY_LIGHT;
}, function (_ref5) {
  var colorArrow = _ref5.colorArrow;
  return colorArrow ? colorArrow : _colors.COLORS.GRAY_DARK;
}, _index.wideBreakpoints.mobile);

var Border = _styledComponents["default"].div.withConfig({
  displayName: "Accordion__Border",
  componentId: "dvcmv9-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    height: 1px;\n    width: 100%;\n    background: transparent;\n    margin: 8px 0;\n"])));

var AccordionBody = _styledComponents["default"].div.withConfig({
  displayName: "Accordion__AccordionBody",
  componentId: "dvcmv9-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    width: 100%;\n    max-height: ", ";\n    ", ";\n    overflow: hidden;\n    transition: max-height 0.2s ", ";\n\n    @media (max-width: ", ") {\n        ", ";\n    }\n"])), function (props) {
  return props.open ? '100%' : '0';
}, _index2.FONTS.S, function (props) {
  return props.open ? 'ease-in' : 'ease-out';
}, _index.wideBreakpoints.mobile, _index2.FONTS.XS);

var DEFAULT_THEME = 'light';
/**
 * @deprecated
 * use instead @r1-frontend/ui-react/src/components/accordions/Accordion/index
 */

var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);

  var _super = _createSuper(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      _this.props.toggle();

      _this.setState(function (state) {
        return {
          open: !state.open
        };
      });
    });

    _this.state = {
      open: props.defaultOpen
    };
    return _this;
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title,
          _this$props$open = _this$props.open,
          open = _this$props$open === void 0 ? this.state.open : _this$props$open,
          _this$props$onOpen = _this$props.onOpen,
          onOpen = _this$props$onOpen === void 0 ? this.toggle : _this$props$onOpen,
          theme = _this$props.theme,
          customTheme = _this$props.customTheme,
          withDividingBorder = _this$props.withDividingBorder,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var colors = _themes["default"][theme] || _themes["default"][DEFAULT_THEME];

      if (customTheme) {
        colors = _objectSpread(_objectSpread({}, colors), customTheme);
      }

      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: colors
      }, /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
        open: open
      }, rest), /*#__PURE__*/_react["default"].createElement(AccordionTitle, {
        onClick: onOpen,
        "data-test": "title"
      }, /*#__PURE__*/_react["default"].createElement(Title, {
        itemProp: "name"
      }, title), /*#__PURE__*/_react["default"].createElement(Icon, {
        open: open,
        colorArrow: open ? colors.colorArrowIsOpen : colors.colorArrow,
        backgroundIcon: open ? colors.backgroundIconIsOpen : colors.backgroundIcon,
        borderIcon: open ? colors.borderIconIsOpen : colors.borderIcon
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "18",
        cy: "18",
        r: "17.25",
        strokeWidth: "1.5",
        transform: "rotate(90 18 18)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M25.92 21.05L19.4 14.53C18.63 13.76 17.37 13.76 16.6 14.53L10.08 21.05",
        strokeWidth: "1.5",
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })))), /*#__PURE__*/_react["default"].createElement(AccordionBody, {
        open: open,
        itemScope: true,
        itemProp: "acceptedAnswer",
        itemType: "https://schema.org/Answer"
      }, withDividingBorder && /*#__PURE__*/_react["default"].createElement(Border, null), children)));
    }
  }]);

  return Accordion;
}(_react["default"].Component);

exports["default"] = Accordion;

_defineProperty(Accordion, "propTypes", {
  defaultOpen: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  withDividingBorder: _propTypes["default"].bool,
  toggle: _propTypes["default"].func,
  customTheme: _propTypes["default"].object
});

_defineProperty(Accordion, "defaultProps", {
  defaultOpen: false,
  withDividingBorder: true,
  theme: DEFAULT_THEME,
  customTheme: {},
  toggle: function toggle() {}
});